import { connect } from 'react-redux'
import { setWizards, resetTradeInWizard } from 'core/components/wizard/actions'

import TradeIn from './TradeIn'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeInConfig: state.configuration.campaign.tradeInConfig
})

const mapDispatchToProps = {
  setWizards,
  resetTradeInWizard
}

export default connect(mapStateToProps, mapDispatchToProps)(TradeIn)
